// Brazilian mobile phone mask utilities (DDD + 9 + 8 dígitos = 11 dígitos)

export function applyPhoneMask(value: string): string {
  let raw = value.replace(/\D/g, "").substring(0, 11);
  // Força "9" como 3º dígito (após DDD) quando já temos DDD
  if (raw.length >= 3 && raw[2] !== "9") {
    raw = raw.substring(0, 2) + "9" + raw.substring(2);
    raw = raw.substring(0, 11);
  }
  if (raw.length === 0) return "";
  if (raw.length <= 2) return "(" + raw;
  if (raw.length <= 7)
    return "(" + raw.substring(0, 2) + ") " + raw.substring(2);
  return (
    "(" +
    raw.substring(0, 2) +
    ") " +
    raw.substring(2, 7) +
    "-" +
    raw.substring(7)
  );
}

export function isValidBRPhone(value: string): {
  ok: boolean;
  reason?: string;
} {
  const digits = value.replace(/\D/g, "");
  if (digits.length !== 11) {
    return {
      ok: false,
      reason: "Informe DDD + número (ex.: (44) 99999-9999).",
    };
  }
  if (digits[2] !== "9") {
    return { ok: false, reason: "O número deve começar com 9 após o DDD." };
  }
  return { ok: true };
}

/** Strip any +55 / 55 country code so webhook never receives it */
export function stripBrCountryCode(value: string): string {
  let v = value.trim();
  v = v.replace(/^\+?55\s*/, "");
  return v;
}

export function attachPhoneMask(el: HTMLInputElement | null): () => void {
  if (!el) return () => {};
  const apply = () => {
    const masked = applyPhoneMask(el.value);
    if (el.value !== masked) el.value = masked;
  };
  el.addEventListener("input", apply);
  el.addEventListener("blur", apply);
  return () => {
    el.removeEventListener("input", apply);
    el.removeEventListener("blur", apply);
  };
}
